import { createContext, useContext, useState, useEffect } from 'react';
import { apiUrl, fetchWithLog } from '../utils/apiBase';

const AuthContext = createContext();

export function AuthProvider({ children }) {
  const [token, setToken] = useState(localStorage.getItem('ktv-token'));
  const [user, setUser] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [isInitialized, setIsInitialized] = useState(false);

  // Funzione di login
  const login = async (username, password) => {
    setIsLoading(true);
    try {
      console.log('🔑 Tentativo di login...');
      
      const response = await fetchWithLog(apiUrl('/api/auth/login'), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ username, password }),
      });
      
      const data = await response.json();
      
      if (response.ok && data.success) {
        console.log('✅ Login riuscito:', data.user);
        setToken(data.token);
        setUser(data.user);
        localStorage.setItem('ktv-token', data.token);
        return { success: true };
      } else {
        console.log('❌ Login fallito:', data.error);
        return { success: false, error: data.error || 'Credenziali non valide' };
      }
    } catch (error) {
      console.error('❌ Errore durante il login:', error);
      return { success: false, error: 'Errore di connessione' };
    } finally {
      setIsLoading(false);
    }
  };

  // Funzione di logout
  const logout = () => {
    console.log('🚪 Logout...');
    setToken(null);
    setUser(null);
    localStorage.removeItem('ktv-token');
  };

  // Auto-verifica token all'avvio
  useEffect(() => {
    const initializeAuth = async () => {
      if (token) {
        console.log('🔍 Verifica token esistente...');
        try {
          const response = await fetchWithLog(apiUrl('/api/auth/verify'), {
            headers: { 'Authorization': `Bearer ${token}` }
          });
          
          const data = await response.json();
          
          if (data.valid && data.user) {
            console.log('✅ Token valido:', data.user);
            setUser(data.user);
          } else {
            console.log('❌ Token non valido, logout automatico');
            logout();
          }
        } catch (error) {
          console.error('❌ Errore verifica token:', error);
          logout();
        }
      }
      setIsInitialized(true);
    };

    initializeAuth();
  }, [token]);

  const value = {
    token,
    user,
    isLoading,
    isInitialized,
    isAuthenticated: !!token && !!user,
    login,
    logout
  };

  console.log('🔐 AuthContext state:', {
    hasToken: !!token,
    hasUser: !!user,
    isAuthenticated: !!token && !!user,
    isInitialized,
    username: user?.username
  });

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};
